// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License. See License.txt in the project root for license information.
export { XhrHttpClient as DefaultHttpClient } from "./xhrHttpClient";
//# sourceMappingURL=defaultHttpClient.browser.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@azure/ms-rest-js/es/lib/defaultHttpClient.browser.js
// module id = 340
// module chunks = 0